import { FormControl, FormLabel, Input, VStack } from "@chakra-ui/react";
import React from "react";

const MainInput = ({
  label,
  error,
  placeholder,
  register,
  name,
  type = "text",
  defaultValues,
  required = true,
}) => {
  return (
    <FormControl isInvalid={Boolean(error)}>
      <VStack align="stretch" spacing={2}>
        {label && (
          <FormLabel
            m={0}
            htmlFor={name}
            fontSize="14px"
            fontWeight="700"
            color="#7A1422"
            textAlign="left"
          >
            {label}
          </FormLabel>
        )}
        <Input
          id={name}
          type={type}
          borderColor={error ? "red" : "#D6CEC0"}
          placeholder={placeholder}
          size="md"
          bg="#F7F2EC"
          border="1px solid"
          borderRadius="lg"
          _focus={{
            borderColor: "#7A1422",
            boxShadow: "0 0 0 1px rgba(122, 20, 34, 0.22)",
          }}
          defaultValue={defaultValues}
          {...register(name, required ? { required: "هذه المعلومات مطلوبة" } : {})}
        />
      </VStack>
    </FormControl>
  );
};

export default MainInput;